import { AnalyticsBrowser, type JSONObject } from "@segment/analytics-next"

import Config from "@/config"

export type JsonMap = JSONObject

export const segment = AnalyticsBrowser.load({
  writeKey: Config.SEGMENT_WRITE_KEY,
})

export const getSegmentAnonUserId = async () => {
  return (await segment.user()).load().anonymousId()
}
